
function autocomplete({section, dropdownItems, shadowRoot, isZip, popularTax, showList, maxDDItems}) {
    if(!section) return
    const inp = section.querySelector("input");
    let matches = 0;
    var currentFocus;
    /*execute a function when someone writes in the text field:*/
    const errorElmt = section.querySelector('.error_msg');
    const warningElmt = section.querySelector('.warn_msg');
    const splitZipElmt = section.querySelector('#split-zip');
    function hide(elmt){
      if(elmt && elmt.className.includes('error_msg')){
        const inputEl = elmt.parentElement.querySelector('input')
        inputEl.classList.remove("invalid");
        inputEl.removeAttribute('required')
      }
      if(elmt){
        elmt.setAttribute('style', "display: none;")
      }
    }
    function show(elmt){
      if(elmt && elmt.className.includes('error_msg')){
        const inputEl = elmt.parentElement.querySelector('input')
        inputEl.className = 'invalid'
        inputEl.setAttribute('required', "required")
      }
      if(elmt){
        elmt.setAttribute('style', "display: block;")
      }
    }
    function autoFillOrDisplayError(){
      const inputElmnt = section.querySelector("input")
      const inputSelection = inputElmnt.userSelection
      const searchButton = shadowRoot.getElementById("search-button")
      const formReset = searchButton ? searchButton.formReset : null
      closeAllLists();
      if(!inputSelection && !formReset) {
        // If user entry is an exact match of a data item then set userSelection to that term on blur. aka auto select
        if(arrLower.includes(inputElmnt.value.toLowerCase())){
          inputElmnt.userSelection = inputElmnt.value
          hide(errorElmt)
          hide(warningElmt)
          if(isZip) hide(splitZipElmt)
        }
        // If there is only one matching term then set userSelection to that term on blur. aka auto complete
        else if(matches === 1 && inputElmnt.value){
          const matchIndex = dropdownItems.findIndex(element => element.toLowerCase().includes(inputElmnt.value.toLowerCase()))
          const matchString = dropdownItems[matchIndex]
          inputElmnt.userSelection = matchString
          inputElmnt.value = matchString
          hide(errorElmt)
          hide(warningElmt)
          if(isZip) hide(splitZipElmt)
        }
        // If user entry is not an exact match of a data value we are in an error state on blur
        else {
          inputElmnt.setAttribute('required', "required")
          if(isZip){
            const val = inputElmnt.value;
            // split zip case
            if(val.length > 4 && matches > 1){
              hide(errorElmt)
              hide(warningElmt)
              show(splitZipElmt)
              splitZipElmt.setAttribute('class', "zip_error_msg")
            }
            // non split error state for zip code input
            else{
              hide(warningElmt)
              hide(splitZipElmt)
              show(errorElmt)
            }
          }
          // error state for non zip input
          else{
            hide(warningElmt)
            show(errorElmt)
          }
        }
      }
    }
    function generateSelectionList(object, popularTax, showList, maxDDItems){
      var a,
        b,
        i,
        val = object.value;
      dropdownItems = sortInputFirst(dropdownItems, val, popularTax)
      matches = 0
      /*close any already open lists of autocompleted values*/
      closeAllLists();
      if (!val && !showList) {
        return false;
      }
      currentFocus = -1;
      /*create a DIV element that will contain the items (values):*/
      a = shadowRoot.appendChild(document.createElement("div"));
      // a = shadowRoot.createElement("DIV");
      a.setAttribute("id", object.id + "-autocomplete-list");
      a.setAttribute("class", "autocomplete-items");
      /*append the DIV element as a child of the autocomplete container:*/
      object.parentNode.appendChild(a);
      /*for each item in the array...*/
      const maximumDropDownItems = maxDDItems || 50
      let renderedDropDownItems = 0
      if(showList && !val){
        for (i = 0; i < dropdownItems.length && renderedDropDownItems < maximumDropDownItems; i++) {
            b = shadowRoot.appendChild(document.createElement("div"));
            b.classList.add("taxonomy-list-item");
            /*insert a input field that will hold the current array item's value:*/
            b.innerHTML = dropdownItems[i]
            b.innerHTML += `<input type="hidden" value="${dropdownItems[i]}">`;
            /*execute a function when someone clicks on the item value (DIV element):*/
            b.addEventListener("click", function () {
              /*insert the value for the autocomplete text field:*/
              inp.value = this.getElementsByTagName("input")[0].value;
              inp.userSelection = inp.value
              console.log("autocomplete 1", inp.value)
              const inputField = section.querySelector("input")
              const inputSelection = inputField.userSelection
              //if user has made both required selections enable the search button
              if(inputSelection){
                hide(errorElmt)
                if(isZip) hide(splitZipElmt)
              }
              /*close the list of autocompleted values,
              (or any other open lists of autocompleted values:*/
              closeAllLists();
            });
            a.appendChild(b);
        }
      }
      for (i = 0; i < dropdownItems.length && renderedDropDownItems < maximumDropDownItems; i++) {
        /*check if the item starts with the same letters as the text field value:*/
        if (dropdownItems[i].toLowerCase().includes(val.toLowerCase())) {
          matches++
          renderedDropDownItems++
          const firstCharSelected = dropdownItems[i].toLowerCase().indexOf(val.toLowerCase())
          /*create a DIV element for each matching element:*/
          const listItem = document.createElement("div")
          b = shadowRoot.appendChild(listItem);
          /*make the matching letters bold:*/
          const beforeSelection = dropdownItems[i].substring(0, firstCharSelected);
          const userSelection = dropdownItems[i].substring(firstCharSelected, firstCharSelected + val.length);
          const afterSelection = dropdownItems[i].substring(firstCharSelected + val.length, dropdownItems[i].length);
          b.innerHTML = beforeSelection;
          b.innerHTML +=
            "<strong>" + userSelection + "</strong>";
          b.innerHTML += afterSelection;
          b.classList.add("taxonomy-list-item");
          b.style.fontFamily = "Sans-serif"
          if(popularTax){
            let popularTaxLower  = popularTax.map( s => s.toLowerCase())
            if(popularTaxLower.includes(`${beforeSelection}${userSelection}${afterSelection}`.toLowerCase())){
              b.style.backgroundColor = '#EBF3FF';
              // this can be used to create a 'popular' label below the list item
              const innerDiv = document.createElement("div")
              innerDiv.innerHTML = 'Popular'
              innerDiv.style.color = '#6b6b6b'
              innerDiv.style.fontSize = '13px'
              innerDiv.style.fontFamily = "Sans-serif"
              innerDiv.style.backgroundColor = 'rgba(255, 255, 255, 0)';
              innerDiv.style.padding = '0px';
              innerDiv.style.margin = '-8px 0px';
              b.appendChild(innerDiv);
            }
          }

          /*insert a input field that will hold the current array item's value:*/
          b.innerHTML += `<input type="hidden" value="${dropdownItems[i]}">`;
          /*execute a function when someone clicks on the item value (DIV element):*/
          b.addEventListener("click", function () {
            /*insert the value for the autocomplete text field:*/
            inp.value = this.getElementsByTagName("input")[0].value;
            inp.userSelection = inp.value

            // trigger input event to update the model and allow for data watching
            var event = new Event('input', {
              bubbles: true,
              cancelable: true,
            });
            inp.dispatchEvent(event);

            const inputField = section.querySelector("input")
            const inputSelection = inputField.userSelection

            //if user has made both required selections enable the search button
            if(inputSelection){
              hide(errorElmt)
              if(isZip) hide(splitZipElmt)
            }
            /*close the list of autocompleted values,
            (or any other open lists of autocompleted values:*/
            closeAllLists();
          });
          a.appendChild(b);
        }
      }
      // If there are no matches then the user is in a warning state
      if(matches === 0){
        hide(errorElmt)
        show(warningElmt)
      }
      else{
        hide(warningElmt)
        hide(errorElmt)
        if(isZip) hide(splitZipElmt)
      }
    }
    inp.addEventListener("input", function () {
      generateSelectionList(this, popularTax, showList, maxDDItems)
    });
    /*execute a function presses a key on the keyboard:*/
    inp.addEventListener("keydown", function (e) {
      // If user enters new keystroke set the userSelection attr to null on the input element
      // and disable the search button
      inp.userSelection = null
      var x = shadowRoot.getElementById(this.id + "-autocomplete-list");
      if (x) x = x.getElementsByClassName("taxonomy-list-item")
      // Handle ENTER key on main input field.

      if (e.keyCode == 13) {
          e.preventDefault();
        // If a value has been entered into he field then check for autocomplete and cick search
        if(currentFocus === -1){
          autoFillOrDisplayError();
          shadowRoot.getElementById('search-button').click();
        }
        // If no value has been entered click search - this will throw errors.
        if(currentFocus === undefined){
          shadowRoot.getElementById('search-button').click();
        }
      }
      if(!x || !x.length) return
      if (e.keyCode == 40) {
        /*If the arrow DOWN key is pressed,
         increase the currentFocus variable:*/
        currentFocus++;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 38) {
        //up
        /*If the arrow UP key is pressed,
      decrease the currentFocus variable:*/
        currentFocus--;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 13) {
        /*If the ENTER key is pressed, prevent the form from being submitted,*/
        e.preventDefault();
        if (currentFocus > -1) {
          /*and simulate a click on the "active" item:*/
          if (x) x[currentFocus].click();
        }
      }
    });
    function sortInputFirst(terms, userInput, popularTax) {
        var firstLetterMatch = [];
        var middleLetterMatch = [];
        userInput = userInput.toLowerCase()
        for (var i = 0; i < terms.length; i++) {
            if (terms[i].toLowerCase().indexOf(userInput) === 0) {
                firstLetterMatch.push(terms[i]);
            } else{
                middleLetterMatch.push(terms[i]);
            }
        }
        firstLetterMatch.sort();
        middleLetterMatch.sort();

        if(popularTax){
          var firstLetterPopular = []
          var middleLetterPopular = []
            // remove popular items from firstLetterMatch, middleLetterMatch arrays and put them at the top of sort.
            for(const tax of popularTax){
              let index1 = firstLetterMatch.indexOf(tax)
              let index2 = middleLetterMatch.indexOf(tax)
              let trm1
              let trm2
              if(index1 > -1) trm1 = firstLetterMatch.splice(index1, 1)
              if(index2 > -1) trm2 = middleLetterMatch.splice(index2, 1)
              if(trm1 && trm1[0]) firstLetterPopular.push(trm1[0])
              if(trm2 && trm2[0]) middleLetterPopular.push(trm2[0])
            }
          firstLetterPopular.sort();
          middleLetterPopular.sort();
          return firstLetterPopular.concat(middleLetterPopular.concat(firstLetterMatch.concat(middleLetterMatch)))
        }
        else {
          return firstLetterMatch.concat(middleLetterMatch)
        }
    }
    function addActive(x) {
      /*a function to classify an item as "active":*/
      if (!x) return false;
      /*start by removing the "active" class on all items:*/
      removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if(!currentFocus) currentFocus = 0;
      if (currentFocus < 0) currentFocus = x.length - 1;
      /*add class "autocomplete-active":*/
      x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
      /*a function to remove the "active" class from all autocomplete items:*/
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    }
    function closeAllLists(elmnt) {
      /*close all autocomplete lists in the shadowRoot,
       except the one passed as an argument:*/
      var x = section.querySelectorAll(".autocomplete-items");
      for (var i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != inp) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    }
    // we may want this in the future if we remove or modify the onblur event
    /*execute a function when someone clicks in the shadowRoot:*/
    // shadowRoot.addEventListener("click", function (e) {
    //   closeAllLists(e.target);
    // });
    const arrLower = dropdownItems.map(el => el.toLowerCase())
    // If user focus' on an input then clear all errors and warnings
    inp.addEventListener('focus', function(){
      if(showList) generateSelectionList(this, popularTax, showList, maxDDItems)
      hide(errorElmt)
      hide(warningElmt)
      if(isZip) hide(splitZipElmt)
      if(shadowRoot.getElementById("search-button")){
        shadowRoot.getElementById("search-button").formReset = false
    }
      const inputEl = section.querySelector("input")
      if(inputEl.value) generateSelectionList(inputEl, popularTax, showList, maxDDItems)
    });
    // If user selects the clear button (x) in the input field then clear all errors and warnings
    inp.addEventListener("search", function() {
      hide(errorElmt)
      hide(warningElmt)
      if(isZip) hide(splitZipElmt)
    });
    inp.addEventListener("blur", function(){
      const onBlurDelay = 350
      // delay onBlur actions so that click events execute first
      // For example when user selects from the drop down list we want that click event
      // to execute before the onBlue closes the list and displays an error.
      setTimeout(function(){
        autoFillOrDisplayError();
      }, onBlurDelay);
    });
  }

  function getPhoneFormatted (phone) {
    let phoneNumber
    if (typeof phone === 'string') phoneNumber = phone
    else  phoneNumber = phone && phone.number ? phone.number : "";
    var cleaned = ("" + phoneNumber).replace(/\D/g, "");
    
    if (phoneNumber.length === 10) {
      var match10 = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      return `(${match10[1]}) ${match10[2]}-${match10[3]}`
    }
    if (phoneNumber.length === 11 && phoneNumber[0] === '1') {
      var match11 = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
      return `${match11[1]}-${match11[2]}-${match11[3]}-${match11[4]}`
    }
    return phoneNumber;
  }

module.exports = {
    autocomplete,
    getPhoneFormatted
  }
